import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import { tradeBySlug, tradePath } from "@/lib/localSeo";
import TradeLanding from "@/pages/local/TradeLanding";

export const Route = createFileRoute("/contractor-websites/remodeling-contractors")({
  component: TradeLanding,
  head: () => {
    const trade = tradeBySlug("remodeling");
    const term = trade?.designTerm ?? `${trade?.label ?? "Contractor"} Contractor Web Design`;
    return pageHead({
      title: `${term} | Seattle & Puget Sound, WA | jaik`,
      description:
        trade?.seoDescription ??
        `Web design and local SEO built for Puget Sound ${trade?.business ?? "contractors"}. Service pages, Google Business Profile work and lead capture that fills your schedule. Free mockup.`,
      path: tradePath("remodeling"),
    });
  },
});
